import { gql } from "lib/apolloClient";
import { curriculumProgramFragment } from "./Fragments";

export const getStaffCurriculumProgramsQuery = gql`
  query getStaffCurriculumPrograms(
    $id: ID!
    $userCurriculumProgramFilters: UserCurriculumProgramFilter
  ) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        id
        curriculumPrograms(filters: $userCurriculumProgramFilters) {
          ...curriculumProgramBasicDetailsItem
        }
      }
    }
  }
  ${curriculumProgramFragment.curriculumProgramBasicDetails}
`;

export const getStaffCoursesQuery = gql`
  query getStaffCourses(
    $id: ID!
    $first: Int
    $after: String
    $filters: CourseFilter
    $fetchTemplates: Boolean!
    $courseGradeFilters: CourseGradeFilters
  ) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        coursesV2(
          first: $first
          after: $after
          orderBy: TITLE
          orderByDirection: ASC
          filters: $filters
        ) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              title
              academicYear
              grades(filters: $courseGradeFilters) {
                id
                name
                globalGrade {
                  id
                  uid
                }
              }
              primaryGrade(filters: $courseGradeFilters) {
                id
                plannerTemplates(filters: { templateType: [UNIT_PLAN] })
                  @include(if: $fetchTemplates) {
                  id
                  name
                  unitType
                  curriculum {
                    id
                  }
                }
              }
              subjects {
                id
                name
              }
              academicYears {
                id
                startDate
                endDate
              }
            }
          }
        }
      }
    }
  }
`;

export const getStaffLearningCoursesQuery = gql`
  query getStaffCourses(
    $id: ID!
    $first: Int
    $after: String
    $filters: StaffLearningCourseFilters
    $fetchTemplates: Boolean!
    $courseGradeFilters: LearningCourseGradeFilters
  ) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        learningCourses(
          first: $first
          after: $after
          orderBy: TITLE
          orderByDirection: ASC
          filters: $filters
        ) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              title
              academicYears {
                id
              }
              grades(filters: $courseGradeFilters) {
                id
                name
                globalGrade {
                  id
                  uid
                }
              }
              primaryGrade(filters: $courseGradeFilters) {
                id
                plannerTemplates(filters: { templateType: [UNIT_PLAN] })
                  @include(if: $fetchTemplates) {
                  id
                  name
                  unitType
                  curriculum {
                    id
                  }
                }
              }
              subjects {
                id
                name
              }
              academicYears {
                id
                startDate
                endDate
              }
            }
          }
        }
      }
    }
  }
`;

export const getCurriculumCoursesQuery = gql`
  query getCurriculumCourses(
    $id: ID!
    $first: Int
    $after: String
    $filters: CourseFilterInput
    $fetchTemplates: Boolean!
    $courseGradeFilters: CourseGradeFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        courses(
          first: $first
          after: $after
          orderBy: TITLE
          orderByDirection: ASC
          filters: $filters
        ) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              title
              academicYear
              grades(filters: $courseGradeFilters) {
                id
                name
                globalGrade {
                  id
                  uid
                }
              }
              primaryGrade(filters: $courseGradeFilters) {
                id
                plannerTemplates(filters: { templateType: [UNIT_PLAN] })
                  @include(if: $fetchTemplates) {
                  id
                  name
                  unitType
                  curriculum {
                    id
                  }
                }
              }
              subjects {
                id
                name
              }
              academicYears {
                id
                startDate
                endDate
              }
            }
          }
        }
      }
    }
  }
`;

export const getCurriculumLearningCoursesQuery = gql`
  query getCurriculumCourses(
    $id: ID!
    $first: Int
    $after: String
    $filters: LearningCourseFilters
    $fetchTemplates: Boolean!
    $courseGradeFilters: LearningCourseGradeFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        learningCourses(
          first: $first
          after: $after
          orderBy: TITLE
          orderByDirection: ASC
          filters: $filters
        ) {
          count {
            totalCount
          }
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              title
              academicYears {
                id
              }
              grades(filters: $courseGradeFilters) {
                id
                name
                globalGrade {
                  id
                  uid
                }
              }
              primaryGrade(filters: $courseGradeFilters) {
                id
                plannerTemplates(filters: { templateType: [UNIT_PLAN] })
                  @include(if: $fetchTemplates) {
                  id
                  name
                  unitType
                  curriculum {
                    id
                  }
                }
              }
              subjects {
                id
                name
              }
              academicYears {
                id
                startDate
                endDate
              }
            }
          }
        }
      }
    }
  }
`;
